/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { takeLatest, put, call, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { uniq, omit } from 'lodash';
import { setNotification } from 'utils';
import { change, formValueSelector } from 'redux-form';
import { delay } from 'redux-saga';
import * as QuoteApi from '../api/quoteApi';
import { getUsersApi } from '../api/userApi';
import { userDataApi } from '../api/layoutApi';
import { addOrderItemApi } from '../api/orderApi';
import { getContactsApi } from '../api/customerApi';
import * as Macros from './macros';
import * as QuoteTypes from '../types/quoteTypes';
import { LOAD_CUSTOMER_QUOTES } from '../types/customerTypes';
import * as QuoteActions from '../actions/quoteActions';
import {
    getUserDataRes,
    getUserDataErr,
} from '../actions/layoutActions';

const selector = formValueSelector('quoteForm');

const getLayout = state => state.layout;
const getQuote = state => state.quote;
const getQuoteItems = state => selector(state, 'quoteItems');


// L O A D   Q U O T E

function* loadQuotesSenderSaga(action) {
    try {
        let senderIDS = [];
        if (action.quoteData.length > 0) {
            action.quoteData.forEach((hit) => {
                senderIDS.push(hit.sales_man_id);
            });
        }
        senderIDS = uniq(senderIDS);
        const resultSender = yield getUsersApi({ filter: JSON.stringify({ _id: senderIDS }) });
        if (resultSender.status === 200) {
            yield put(QuoteActions.loadQuotesSenderRes(resultSender.data));
        }
    } catch (e) {
        console.log(e);
        yield put(QuoteActions.loadQuotesSenderErr());
    }
}

function* loadQuotesContactSaga(action) {
    try {
        const result = yield QuoteApi.getQuoteApi({ filter: JSON.stringify({ customer_id: action.customerId }) });

        let contactIDS = [];
        if (result.status === 200) {
            if (result.data.hits.length > 0) {
                result.data.hits.forEach((hit) => {
                    contactIDS.push(hit.contact_id);
                });
            }

            contactIDS = uniq(contactIDS);
            const resultContact = yield getContactsApi({ filter: JSON.stringify({ customer_id: action.customerId }), limit: 999 });
            if (resultContact.status === 200) {
                yield call(loadQuotesSenderSaga, { quoteData: result.data.hits });
                yield put(QuoteActions.loadQuotesContactRes(resultContact.data));
            }
        }
    } catch (e) {
        yield put(QuoteActions.loadQuotesContactErr());
        console.log(e);
    }
}

function* loadQuoteSaga(action) {
    try {
        const params = { filter: JSON.stringify({ quote_reference: action.id }) };

        const result = yield QuoteApi.getQuoteApi(params);

        if (result.status === 200 && result.data.hits.length > 0) {
            const quote = result.data.hits[0];

            let userIDS = [quote.created_user, quote.updated_by, quote.sales_man_id];
            let configurationIDS = [];
            let addressIDS = [];
            let productGroupIDS = [];
            let commentUserIDS = [];

            quote.items.forEach((quoteItem) => {
                userIDS.push(quoteItem.created_user);
                productGroupIDS.push(quoteItem.product_group_id);
                commentUserIDS = [...commentUserIDS, ...quoteItem.comments.map(comment => comment.created_by)];
                configurationIDS = [...configurationIDS, ...quoteItem.configurations.map(configuration => configuration.configuration_id)];
                addressIDS = [...addressIDS, ...quoteItem.shipping_details.map(address => address.address_id)];
            });

            productGroupIDS = uniq(productGroupIDS);
            userIDS = uniq([...userIDS, ...commentUserIDS]);
            configurationIDS = uniq(configurationIDS);
            addressIDS = uniq(addressIDS);

            yield call(loadQuotesContactSaga, { customerId: quote.customer_id });
            yield put(QuoteActions.loadQuoteRes(quote));

            const macroProductGroups = yield Macros.getProductGroupsMacro(productGroupIDS);
            const macroUsers = yield Macros.getUsersMacro(userIDS);
            const macroConfigurations = yield Macros.getConfigurationsMacro(configurationIDS);
            const macroBillingAddresses = yield Macros.getAddressesMacro(quote.address_id, 'BILLING');
            const macroContact = yield Macros.getContactsMacro(quote.contact_id);

            const users = macroUsers.data.hits;
            const billings = macroBillingAddresses.data.hits;
            const configurations = macroConfigurations.data.hits;
            const productGroups = macroProductGroups.data.hits;
            const contact = macroContact.data.hits;

            yield put(QuoteActions.setQuoteNeededData({
                users,
                billings,
                configurations,
                productGroups,
                contact,
            }));
            /*
            quote.created_user = users.find(u => u._id === quote.created_user);
            quote.updated_by = users.find(u => u._id === quote.updated_by);
            quote.sales_man_id = users.find(u => u._id === quote.sales_man_id);
            quote.address_id = billingAddresses.find(a => a._id === quote.address_id); */
        } else {
            yield put(push('/404'));
        }
    } catch (e) {
        yield put(QuoteActions.loadQuoteErr());
        console.log(e);
    }
}

export function* loadQuoteWatcher() {
    yield takeLatest(QuoteTypes.LOAD_QUOTE, loadQuoteSaga);
}
// L O A D   Q U O T E

// A D D   N E W   Q U O T E
function* addNewQuoteSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield QuoteApi.addNewQuoteApi(action.data);
        if (result.status === 202) {
            yield put(QuoteActions.addNewQuoteRes(action.data));
            yield put(change('quoteForm', 'quote_id', action.data.quote_id));

            const params = { filter: JSON.stringify({ _id: action.data.quote_id }) };
            const resultQuote = yield QuoteApi.getQuoteApi(params);

            yield put(change('quoteForm', 'quote_data', resultQuote.data.hits[0]));

            setNotification('success', locale, 'global.success', 'quote.notification.addQuoteSuccess');
            yield put(push(`/quotes/view/${resultQuote.data.hits[0].quote_reference}`));
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: false });
            yield put(QuoteActions.addNewQuoteErr());
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'quote.notification.addQuoteError');
        yield put(QuoteActions.addNewQuoteErr());
        console.log(e);
    }
}

export function* addNewQuoteWatcher() {
    yield takeLatest(QuoteTypes.ADD_NEW_QUOTE, addNewQuoteSaga);
}
// A D D   N E W   Q U O T E

// C A N C E L   Q U O T E
function* cancelQuoteSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale, userData } = layout;
        const param = {
            quote_id: action.quoteId,
            status: 'CANCELED',
            user_id: userData.data._id,
        };

        const result = yield QuoteApi.cancelQuoteApi(param);
        if (result.status === 202) {
            yield put(QuoteActions.cancelQuoteRes(true, false));
            yield put(QuoteActions.cancelQuoteRes(false, true));
            yield delay(1000);
            yield put(QuoteActions.cancelQuoteRes(false, false));
            setNotification('success', locale, 'global.success', 'quote.notification.cancelQuoteSuccess');
            yield put({ type: QuoteTypes.LOAD_QUOTE, id: action.quoteReference });
        } else {
            setNotification('error', locale, 'global.error', 'quote.notification.cancelQuoteError');
        }
    } catch (e) {
        console.log(e);
        yield put(QuoteActions.cancelQuoteErr());
    }
}

export function* cancelQuoteWatcher() {
    yield takeLatest(QuoteTypes.CANCEL_QUOTE, cancelQuoteSaga);
}
// C A N C E L   Q U O T E

// C L O N E   Q U O T E
function* cloneQuoteSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield QuoteApi.cloneQuoteApi(action.data);
        if (result.status === 202) {
            yield put(QuoteActions.cloneQuoteRes(action.clonedQuoteId));
            if (action.customerId !== null) {
                yield put({ type: LOAD_CUSTOMER_QUOTES, customerId: action.customerId });
            } else {
                const resultQuote = yield QuoteApi.getQuoteApi({ filter: JSON.stringify({ _id: action.data.quote_id }) });
                if (resultQuote.status === 200) {
                    yield put(push(`/quotes/view/${resultQuote.data.hits[0].quote_reference}`));
                }
            }
            yield delay(500);
            setNotification('success', locale, 'global.success', 'quote.notification.cloneQuoteSuccess');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', 'quote.notification.cloneQuoteError');
            yield put(QuoteActions.cloneQuoteErr(error.message));
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'quote.notification.cloneQuoteError');
        yield put(QuoteActions.cloneQuoteErr());
    }
}

export function* cloneQuoteWatcher() {
    yield takeLatest(QuoteTypes.CLONE_QUOTE, cloneQuoteSaga);
}
// C L O N E   Q U O T E

// C H N G E   Q U O T E   S T A T U S
function* changeQuoteStatusSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale, userData } = layout;
        const param = {
            quote_id: action.quoteId,
            status: action.quoteStatus,
            user_id: userData.data._id,
        };

        const result = yield QuoteApi.changeQuoteStatusApi(param);
        if (result.status === 202) {
            yield put(QuoteActions.changeQuoteStatusRes(true, false));
            yield put(QuoteActions.changeQuoteStatusRes(false, true));
            yield delay(1000);
            yield put(QuoteActions.changeQuoteStatusRes(false, false));
            setNotification('success', locale, 'global.success', `quote.notification.success.${action.quoteStatus}`);
            yield put({ type: QuoteTypes.LOAD_QUOTE, id: action.quoteReference });
        } else {
            setNotification('error', locale, 'global.error', `quote.notification.error.${action.quoteStatus}`);
            yield put(QuoteActions.changeQuoteStatusErr());
        }
    } catch (e) {
        console.log(e);
        yield put(QuoteActions.changeQuoteStatusErr());
    }
}

export function* changeQuoteStatusWatcher() {
    yield takeLatest(QuoteTypes.CHANGE_QUOTE_STATUS, changeQuoteStatusSaga);
}
// C H N G E   Q U O T E   S T A T U S

// E D I T   Q U O T E
function* editQuoteSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield QuoteApi.editQuoteApi(action.data);
        if (result.status === 202) {
            yield put(QuoteActions.editQuoteRes(true, false));
            yield delay(1000);
            yield put(QuoteActions.editQuoteRes(false, true));
            yield delay(1000);
            yield put(QuoteActions.editQuoteRes(false, false));
            setNotification('success', locale, 'global.success', 'quote.notification.editQuoteSuccess');
            yield put({ type: QuoteTypes.LOAD_QUOTE, id: action.quoteReference });
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: false });
            yield put(QuoteActions.editQuoteErr());
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'quote.notification.editQuoteError');
        yield put(QuoteActions.editQuoteErr());
    }
}

export function* editQuoteWatcher() {
    yield takeLatest(QuoteTypes.EDIT_QUOTE, editQuoteSaga);
}
// E D I T   Q U O T E


// A D D   N E W   O R D E R   I T E M
function* addNewQuoteItemSaga(action) {
    const layout = yield select(getLayout);
    const quote = yield select(getQuote);
    const { locale } = layout;

    try {
        const params = action.data.custom ? action.data : omit(action.data, ['configurations']);
        const result = yield addOrderItemApi(params);

        if (result.status === 202) {
            yield put(QuoteActions.addNewQuoteItemRes(false, true));
            yield put(QuoteActions.addNewQuoteItemRes(false, false));

            yield call(loadQuoteSaga, { id: quote.view.data.quote_reference });

            setNotification('success', locale, 'global.success', 'quote.notification.addItemSuccess');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(QuoteActions.addNewQuoteItemErr());
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'quote.notification.addItemError');
        yield put(QuoteActions.addNewQuoteItemErr());
    }
}

export function* addNewQuoteItemWatcher() {
    yield takeLatest(QuoteTypes.ADD_NEW_QUOTE_ITEM, addNewQuoteItemSaga);
}
// A D D   N E W   O R D E R   I T E M


// C L O N E   Q U O T E   I T E M
function* cloneQuoteItemSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;

        const result = yield QuoteApi.addQuoteItemApi(action.data);
        if (result.status === 202) {
            yield put(QuoteActions.cloneQuoteItemRes(action.clonedItemId));
            setNotification('success', locale, 'global.success', 'quote.notification.cloneItemSuccess');
            yield delay(1000);
            yield put({ type: QuoteTypes.LOAD_QUOTE, id: action.quoteId });
        } else {
            setNotification('error', locale, 'global.error', 'quote.notification.cloneItemError');
        }
    } catch (e) {
        console.log(e);
        yield put(QuoteActions.cloneQuoteItemErr());
    }
}

export function* cloneQuoteItemWatcher() {
    yield takeLatest(QuoteTypes.CLONE_QUOTE_ITEM, cloneQuoteItemSaga);
}
// C L O N E   Q U O T E   I T E M

// D E L E T E   Q U O T E   I T E M
function* deleteQuoteItemSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = { item_id: action.quoteItemId };

        const result = yield QuoteApi.deleteQuoteItemApi(params);
        if (result.status === 202) {
            yield put(QuoteActions.deleteQuoteItemRes(action.quoteItemId));
            setNotification('success', locale, 'global.success', 'quote.notification.deleteItemSuccess');
            yield delay(1000);

            if (action.quoteReference) {
                yield put({ type: QuoteTypes.LOAD_QUOTE, id: action.quoteReference });
            } else {
                const quoteItems = yield select(getQuoteItems);
                yield put(change('quoteForm', 'quoteItems', quoteItems.filter(o => o.item_id !== action.quoteItemId)));
            }
        } else {
            setNotification('error', locale, 'global.error', 'quote.notification.deleteItemError');
        }
    } catch (e) {
        console.log(e);
        yield put(QuoteActions.deleteQuoteItemErr());
        setNotification('error', locale, 'global.error', 'quote.notification.deleteItemError');
    }
}

export function* deleteQuoteItemWatcher() {
    yield takeLatest(QuoteTypes.DELETE_QUOTE_ITEM, deleteQuoteItemSaga);
}
// D E L E T E   Q U O T E   I T E M

// E D I T   O R D E R   I T E M
function* editQuoteItemSaga(action) {
    const layout = yield select(getLayout);
    const quote = yield select(getQuote);
    const { locale } = layout;

    try {
        const params = action.data.custom ? action.data : omit(action.data, ['configurations']);
        const result = yield QuoteApi.editQuoteItemApi(params);

        if (result.status === 202) {
            yield put(QuoteActions.editQuoteItemRes(false, true));
            yield put(QuoteActions.editQuoteItemRes(false, false));

            yield call(loadQuoteSaga, { id: quote.view.data.quote_reference });

            setNotification('success', locale, 'global.success', 'order.notification.editItemSuccess');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(QuoteActions.editQuoteItemErr());
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'order.notification.editItemError');
        yield put(QuoteActions.editQuoteItemErr());
    }
}

export function* editQuoteItemWatcher() {
    yield takeLatest(QuoteTypes.EDIT_QUOTE_ITEM, editQuoteItemSaga);
}
// E D I T   O R D E R   I T E M

// G E T   U S E R   D A T A
function* getUserDataToOrderSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const headers = {
            Authorization: `${action.data.token_type} ${action.data.access_token}`,
            'Content-Type': 'application/json',
        };

        const result = yield userDataApi({}, headers);

        if (result.status === 200) {
            const userData = yield result.data;
            yield put(getUserDataRes(userData));
        } else if (result.status === 401) {
            yield put(getUserDataErr());
        } else if (result.status === 500) {
            yield put(getUserDataErr());
        } else {
            yield put(getUserDataErr());
        }
    } catch (e) {
        console.log(e);
        yield put(getUserDataErr());
        setNotification('error', locale, 'global.error', 'error.login.error');
    }
}
// G E T   U S E R   D A T A

//  A D D   N E W   F A V O R I S   Q U O T E
function* addNewFavorisQuoteSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield QuoteApi.addFavorisQuoteApi(action.data);
        if (result.status === 202) {
            yield put(QuoteActions.addNewFavorisQuoteRes(true, false));
            yield put(QuoteActions.addNewFavorisQuoteRes(false, true));
            yield put(QuoteActions.addNewFavorisQuoteRes(false, false));
            setNotification('success', locale, 'global.success', 'quote.notification.addFavorisQuoteSuccess', {}, { placement: 'bottomRight' });
            yield call(getUserDataToOrderSaga, { data: layout.userToken.data });
        } else {
            setNotification('error', locale, 'global.error', 'quote.notification.addMoreThanFavoriteQuoteError', {}, { placement: 'bottomRight' });
            yield put(QuoteActions.addNewFavorisQuoteErr());
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'quote.notification.addFavorisQuoteError', {}, { placement: 'bottomRight' });
        yield put(QuoteActions.addNewFavorisQuoteErr());
    }
}

export function* addNewFavorisQuoteWatcher() {
    yield takeLatest(QuoteTypes.ADD_NEW_FAVORIS_QUOTE, addNewFavorisQuoteSaga);
}
//  A D D   N E W   F A V O R I S   Q U O T E

//  D E L E T E   F A V O R I S   Q U O T E
function* deleteFavorisQuoteSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield QuoteApi.deleteFavorisQuoteApi(action.data);
        if (result.status === 202) {
            yield put(QuoteActions.deleteFavorisQuoteRes(true, false));
            yield put(QuoteActions.deleteFavorisQuoteRes(false, true));
            yield put(QuoteActions.deleteFavorisQuoteRes(false, false));
            setNotification('success', locale, 'global.success', 'quote.notification.delFavorisQuoteSuccess', {}, { placement: 'bottomRight' });
            yield call(getUserDataToOrderSaga, { data: layout.userToken.data });
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(QuoteActions.deleteFavorisQuoteErr());
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'quote.notification.delFavorisQuoteError', {}, { placement: 'bottomRight' });
        yield put(QuoteActions.deleteFavorisQuoteErr());
    }
}

export function* deleteFavorisQuoteWatcher() {
    yield takeLatest(QuoteTypes.DELETE_FAVORIS_QUOTE, deleteFavorisQuoteSaga);
}
//  D E L E T E   F A V O R I S   Q U O T E


// A D D   A D D I T I O N A L   I T E M
function* addQuoteAdditionalItemSaga(action) {
    const layout = yield select(getLayout);
    const quote = yield select(getQuote);
    const { locale } = layout;

    try {
        const result = yield QuoteApi.addQuoteAdditionalItemApi(action.data);
        if (result.status === 202) {
            yield put(QuoteActions.addQuoteAdditionalItemRes(false, true));
            yield put(QuoteActions.addQuoteAdditionalItemRes(false, false));

            yield call(loadQuoteSaga, { id: quote.view.data.quote_reference });
            setNotification('success', locale, 'global.success', 'order.notification.additionalItem.add.success');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(QuoteActions.addQuoteAdditionalItemErr());
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'order.notification.additionalItem.add.error');
        yield put(QuoteActions.addQuoteAdditionalItemErr());
    }
}

export function* addQuoteAdditionalItemWatcher() {
    yield takeLatest(QuoteTypes.ADD_QUOTE_ADDITIONAL_ITEM, addQuoteAdditionalItemSaga);
}
// A D D   A D D I T I O N A L   I T E M


// D E L E T E   A D D I T I O N A L   I T E M
function* deleteQuoteAdditionalItemSaga(action) {
    const layout = yield select(getLayout);
    const quote = yield select(getQuote);
    const { locale } = layout;

    try {
        const result = yield QuoteApi.deleteQuoteAdditionalItemApi(action.data);
        if (result.status === 202) {
            yield put(QuoteActions.deleteQuoteAdditionalItemRes());

            yield call(loadQuoteSaga, { id: quote.view.data.quote_reference });

            setNotification('success', locale, 'global.success', 'order.notification.additionalItem.delete.success');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(QuoteActions.deleteQuoteAdditionalItemErr());
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'order.notification.additionalItem.delete.error');
        yield put(QuoteActions.deleteQuoteAdditionalItemErr());
    }
}

export function* deleteQuoteAdditionalItemWatcher() {
    yield takeLatest(QuoteTypes.DELETE_QUOTE_ADDITIONAL_ITEM, deleteQuoteAdditionalItemSaga);
}
// D E L E T E   A D D I T I O N A L   I T E M
